export default "__VITE_ASSET__DyVAbGzG__"